import React, { useEffect, useState , useRef} from "react";
import { Dropdown, ButtonGroup } from "react-bootstrap";
import { Col, Row, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DefaultButton from "../../../shared/components/DefaultButton";
import { SEARCH } from "../../../shared/constants/Constants";
import { loadChatUserAuditDataRequest, loadUserMetricsDataRequest, loadChatGroupDataRequest } from "../redux/Actions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import exportChatAuditToCSV  from "./ExportCsv";




const AuditUsers = () => {
  let dispatch = useDispatch(); 
  const chatRef = useRef(null);
  let {useraudit, chatgroup, loading} = useSelector((state) => state.chatgroup);
  const [searchTriggered, setSearchTriggered] = useState(false);
  const [messages, setMessages] = useState('');
  const [empid, setempid] = useState('');
  //const [channel, setChannel] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);  
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [selectedExport, setSelectedExport] = useState(null);
  const [exporting, setExporting] = useState(false);
  const columnHeaders = ["Employee Name", "Employee ID", "Timestamp", "Message"];

  
  useEffect(() => {
    dispatch(loadChatGroupDataRequest("all"));
  }, [dispatch]);

 const handleApply = () => {
  const selectedGroup = chatgroup.find((g) => g.id === selectedGroupId);
  const chatName = selectedGroup?.chat_name || '';

  // Ensure empId is provided
    if (!empid) {
        alert('Please fill in the Employee ID.');
        return;
    }

    // Default to one month before today if startDate is missing
    const today = new Date();
    const defaultStartDate = new Date(today);
    defaultStartDate.setMonth(defaultStartDate.getMonth() - 1);

    const request = {
        keyword: messages || "",  // if message is empty, default to empty string
        fromDate: startDate || defaultStartDate,
        toDate: endDate || today,
        empId: empid,
    };
    
    dispatch(loadChatUserAuditDataRequest(request));
    setSearchTriggered(true);
    };



        const getFileNameFromFirebaseUrl = (url) => {
            try {          
            const encodedPath = url.split('/o/')[1].split('?')[0];   
            const decodedPath = decodeURIComponent(encodedPath); 
            const fileName = decodedPath.split('/').pop();
            return fileName;
            } catch (error) {
            console.error("Invalid URL format:", error);
            return null;
            }
        };
        const makeLinksClickable = (text) => {
            const urlRegex = /(https?:\/\/[^\s<]+)/g; // Regex to detect URLs, excluding `<br>` and other tags
            return text
                .replace(urlRegex, (url) => {
                    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
                })
                .replace(/<br\s*\/?>/gi, "<br>"); // Ensure <br> tags are preserved as line breaks
        };
        // Reference for the bottom of the message list
            const messagesEndRef = useRef(null);

            // Scroll to the bottom of the message list
            const scrollToBottom = () => {
                if (messagesEndRef.current) {
                    messagesEndRef.current.scrollIntoView({ behavior: "auto" }); // Instantly scroll to the bottom
                }
            };

       
        const handleExport = () => {
        if (!chatRef.current) return;

        html2canvas(chatRef.current, {
            scale: 2, // Higher scale for better clarity
            useCORS: true
        }).then((canvas) => {
            // Convert to JPEG with lower quality for compression
            const imgData = canvas.toDataURL("image/jpeg", 0.6); // 0.6 = 60% quality

            const pdf = new jsPDF({
            orientation: "portrait",
            unit: "pt",
            format: "a4",
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = canvas.width;
            const imgHeight = canvas.height;

            const ratio = pdfWidth / imgWidth;
            const scaledHeight = imgHeight * ratio;

            let position = 0;
            let heightLeft = scaledHeight;

            while (heightLeft > 0) {
            pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, scaledHeight);
            heightLeft -= pdfHeight;
            position -= pdfHeight;

            if (heightLeft > 0) pdf.addPage();
            }

            pdf.save("chat_audit_compressed.pdf");
        });
        };
        useEffect(() => {
                    const today = new Date();
                    const lastMonth = new Date(today);
                    lastMonth.setMonth(today.getMonth() - 1);
                    setStartDate(lastMonth);
                    setEndDate(today);
                    }, [selectedGroupId]);
        
   
   return (
    <>
        <Card>
    <Card.Body>
        <Row className="gy-3">
            <Col xs={8} md={3}>
            <strong>Employee Id</strong>
            <input type="text" className="form-control"  placeholder="Employee id"  value={empid}  onChange={(e) => setempid(e.target.value)}  />

        </Col>  
         {/* <Col xs={12} md={3}>
            <strong>Channel</strong>
            <select
                className="form-control"
                value={selectedGroupId}
                onChange={(e) => setSelectedGroupId(e.target.value)}
            >
                <option value="">-- Select Channel --</option>
                {chatgroup
                    ?.slice() // Make a shallow copy to avoid mutating the original array
                    .sort((a, b) => a.chat_name.localeCompare(b.chat_name)) // Sort by chat_name
                    .map((group) => (
                        <option key={group.id} value={group.id}>
                            {group.chat_name}
                        </option>
                    ))}
            </select>
        </Col>     */}
        <Col xs={12} md={3}>
            <strong>Message</strong>
            <input type="text" className="form-control"  placeholder="Search message..."  value={messages}  onChange={(e) => setMessages(e.target.value)}  />
        </Col>

       <Col xs={12} md={2}>
            <strong>Start Date</strong>
            <div style={{ position: 'relative', zIndex: 1000 }}>
                <DatePicker
                selected={startDate}
                onChange={(date) => {
                    setStartDate(date);
                    // If the end date is before the new start date, reset it
                    if (endDate && date && endDate < date) {
                    setEndDate(null);
                    }
                }}
                className="form-control"
                placeholderText="Start Date"
                isClearable
                maxDate={new Date()} // Prevent future dates
                />
            </div>
            </Col>

            <Col xs={12} md={2}>
            <strong>End Date</strong>
            <div style={{ position: 'relative', zIndex: 1000 }}>
                <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                className="form-control"
                placeholderText="End Date"
                isClearable
                minDate={startDate}  // Can't be before the start date
                maxDate={new Date()} // Can't be a future date
                disabled={!startDate} // Disable until start date is selected
                />
            </div>
            </Col>

       
         <Col xs={12} md={2} className="d-flex gap-2 align-items-end">
            <DefaultButton
            buttonClass="default-btn-color"
            buttonTitle={SEARCH}
            actionBlock={handleApply}
            />
        </Col>
       <Col xs={12} md={2} className="d-flex align-items-end">
            {searchTriggered && useraudit.data && Object.keys(useraudit.data).length > 0 && (
                // <div className="d-flex flex-column my-3">
                // <Dropdown as={ButtonGroup}>
                //     <Dropdown.Toggle className="default-btn-color">
                //     Export
                //     </Dropdown.Toggle>
                //     <Dropdown.Menu
                //     className="dropdown-custom"
                //     style={{ backgroundColor: "#f28f34", borderColor: "#f28f34" }}
                //     >
                //     <Dropdown.Item onClick={handleExport}>PDF</Dropdown.Item>
                //     <Dropdown.Item onClick={() => exportChatAuditToCSV(useraudit.data)}>CSV</Dropdown.Item>
                //     </Dropdown.Menu>
                // </Dropdown>
                // </div>
                <DefaultButton
                        buttonClass="default-btn-color"
                        buttonTitle={exporting ? (<>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                         Exporting...
                        </>
                        ) : "Export as CSV"}
                        disabled={exporting}
                        actionBlock={() => {
                            setExporting(true);
                            setTimeout(() => {
                            exportChatAuditToCSV('',useraudit.data, columnHeaders);
                            setExporting(false);
                            }, 100);
                        }}
                        />

            )}
        </Col>


        </Row>
    </Card.Body>
    </Card>

    {/* Message display area */}
    <div style={{ flexGrow: 1, height: 'calc(100% - 100px)' }}>
    <Card className="w-100" style={{ height: '100%', padding: 0 }}>                                     
        {/* <div style={{ position: 'sticky',top: 0,backgroundColor: '#f4f4f4',padding: '10px 20px',borderBottom: '1px solid #ddd',fontWeight: 'bold',fontSize: '1.2rem',zIndex: 1, }}>
            {empid ? `Employee ID: ${empid}` : 'Employee ID'}
        </div>  */}
        <Card.Body
            style={{overflowY: 'auto',height: 'calc(100% - 100px)',padding: '20px' }} ref={chatRef}
        >  
        {loading ? (
                    <div className="text-center my-5">
                        <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                        </div>
                        <p>Loading messages...</p>
                    </div>
                    ) :                              
            searchTriggered && useraudit.data && Object.keys(useraudit.data).length > 0 ? (
                Object.entries(useraudit.data).map(([channelName, message]) => (
                    <div key={channelName} style={{ marginBottom: '20px' }}>
                        
                        <div 
                            style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '20px',
                                position: 'relative'
                            }}>
                            <hr
                                style={{
                                    flexGrow: 1,
                                    border: 'none',
                                    borderTop: '1px solid #ff7f0e',
                                    margin: '0 10px',
                                }}
                            />
                            <span
                                style={{
                                    backgroundColor: '#f4f4f4',
                                    padding: '5px 15px',
                                    borderRadius: '20px',
                                    fontWeight: 'bold',
                                    fontSize: '.75rem',
                                    color: '#555',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                            {channelName}
                            </span>
                            <hr
                            style={{
                                flexGrow: 1,
                                border: 'none',
                                borderTop: '1px solid #ff7f0e',
                                margin: '0 10px',
                            }}
                        />
                        </div>
                        
                        {message.map((msg, idx) => (
                            <div
                                key={idx}
                                style={{
                                    marginBottom: '1px',
                                    paddingBottom: '1px'
                                }}
                            >
                                <div>
                                    <strong>
                                        {msg.senderName} {'@'}{msg.senderId}
                                        <span style={{ fontSize: '0.8rem', color: '#999', marginLeft: '10px' }}>
                                            {new Date(msg.timestamp).toLocaleString()}
                                        </span>
                                    </strong>
                                </div>
                                {msg.contentType === "image" ? (
                                    <img
                                        src={msg.contentUrl[0]['fileUrl']}
                                        alt="Message Content"
                                        style={{
                                            width:'360px',
                                            maxWidth: '30%',
                                            height: 'auto',
                                            borderRadius: '5px',
                                            marginTop: '10px',
                                        }}
                                    />
                                ) : msg.contentType === "file" ? (
                                <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                    {/* File Icon */}
                                    <i
                                        className="fas fa-file-alt"
                                        style={{
                                            fontSize: '1.2rem', 
                                            color: '#007bff',
                                            marginRight: '8px',
                                        }}
                                    ></i>

                                    {/* File Name with Link */}
                                    <a
                                        href={msg.contentUrl[0]['fileUrl']}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: 'none',
                                            color: '#007bff',
                                            fontWeight: 'bold',
                                            wordBreak: 'break-word', // Handle long file names
                                        }}
                                    >
                                        {getFileNameFromFirebaseUrl(msg.contentUrl[0]['fileUrl']) }                            
                                    </a>
                                </div>
                                ) : (
                                <div dangerouslySetInnerHTML={{
                                        __html: makeLinksClickable(msg.content.replace(/\n/g, "<br>")),
                                    }}
                                    style={{
                                        whiteSpace: "pre-wrap", // Preserve spaces and line breaks
                                        wordBreak: "break-word", // Handle long URLs
                                    }}
                                ></div>
                                )}
                            </div>
                        ))}
                    </div>
                ))
            ) : searchTriggered ? (
                <p>No messages to display</p>
                ) : (
               <p>Please search to display messages</p>
            )}
            <div ref={messagesEndRef} />
        </Card.Body>                                  
                                    
                                </Card>
                            </div>
                                </>
  );
};

export default AuditUsers;

